import React from 'react';

import {Paper, Stack, Typography} from 'views/components';
import {Translate} from 'views/module';

const WorksCard = (props) => {
  return (
    <Paper
      sx={{
        p: '24px',
        borderRadius: '20px',
        boxShadow: 'none',
        backgroundColor: '#FFFFFF',
      }}
    >
      <Stack sx={{gap: '20px'}}>
        <Typography sx={{fontSize: '24px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', fontFamily: '"Spectral", serif'}}>
          <Translate expression={'caregivermatchingstep.WorksCard.Title'} />
        </Typography>

        <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925', lineHeight: '150%'}}>
          <Translate expression={'caregivermatchingstep.WorksCard.Description'} />
        </Typography>
      </Stack>
    </Paper>
  );
};

export default React.memo(WorksCard);
